import localforage from "localforage";

export default localforage.createInstance({
  name: "self-site-storage",
});
